import React, { useEffect, useState } from "react";
import { Modal, Button, message, Typography } from "antd";
import { useMutation } from '@apollo/client';
import { UPDATE_CATEGORY_PRIORITY } from "./requests";
import { categoryTypes } from "../../../../types";
import DragTable from "./components/DragTable";

const { Text } = Typography;

type PriorityCategoryProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
  data: {
    categories: {
      results: typeof categoryTypes.category[];
    };
  };
  sortRefetch: () => void;
};

const PriorityCategory: React.FC<PriorityCategoryProps> = ({ showModal, setShowModal, refetch, data, sortRefetch }) => {
  const [categories, setCategories] = useState<typeof categoryTypes.category[]>([]);
  const [loading, setLoading] = useState(false);

  const [updateCategoryPriority] = useMutation(UPDATE_CATEGORY_PRIORITY);

  useEffect(() => {
    setLoading(true);
    if (data && data.categories && data.categories.results) {
      setCategories(data.categories.results.map((category: typeof categoryTypes.category, index: number) => ({
        ...category,
        priority: index + 1,
      })));
    } else {
      setCategories([]);
    }
    setLoading(false);
  }, [data, showModal]);

  const handleDragEnd = (newCategories: typeof categoryTypes.category[]) => {
    const updatedCategories = newCategories.map((category, index) => ({
      ...category,
      priority: index + 1,
    }));

    setCategories(updatedCategories);
  };

  const handleSubmit = async () => {
    const categoriesInput = categories.map((category, index) => ({
      id: category.id,
      priority: index + 1,
    }));

    try {
      const response = await updateCategoryPriority({
        variables: { categories: categoriesInput },
      });
      if (response.data.updateCategoryPriority) {
        message.success('Prioridades actualizadas correctamente');
        await refetch();
        await sortRefetch();
      } else {
        message.error('Error al actualizar las prioridades');
      }
    } catch (error) {
      console.error(error);
      message.error('Hubo un problema al actualizar las prioridades');
    } finally {
      setShowModal(false);
    }
  };

  return (
    <Modal
      title="Actualizar Prioridades"
      open={showModal}
      onCancel={() => setShowModal(false)}
      footer={[
        <Button key="cancel" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Guardar
        </Button>,
      ]}
    >
      <Text>Para cambiar el orden de las prioridades, arrastra las filas de la tabla a la posición deseada.</Text>

      <DragTable
        data={categories}
        onDragEnd={handleDragEnd}
        columns={[
          { title: "Orden",
            dataIndex: "priority",
            key: "priority" },
          { title: "Nombre",
            dataIndex: "name",
            key: "name" },
          { title: "Descripción",
            dataIndex: "description",
            key: "description" },
        ]}
        loading={loading}
      />
    </Modal>
  );
};

export default PriorityCategory;
